export default {
  methods: {
    calCVS() {
      var risk = ['0%', '1.3%', '2.2%', '3.2%', '4.0%', '6.7%', '9.8%', '9.6%', '6.7%', '15.2%', 'Error selected both ages'];
      var a = document.CHA2DS2VASCForm.elements;
      var score = +a[2].checked + +a[4].checked;

      for (var i = 8; i--;) {
        if (a[i].checked) {
          score += 1;
        }
      }

      document.getElementById('CHA2DS2VASCscore').innerHTML = score;
      document.getElementById('CHA2DS2VASCrisk').innerHTML = risk[score];
    }

  },
  id: 'eeb395a3f4',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=CHA2DS2VASC><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>CHA<sub>2</sub>DS<sub>2</sub>-VASc</div></div></div><div class=page-content><form name=CHA2DS2VASCForm><div class="list simple-list"><ul><li><span>Congestive heart failure</span> <label class="toggle toggle-init color-green"><input type=checkbox name=C1 @change=calCVS()> <span class=toggle-icon></span></label></li><li><span>Hypertension</span> <label class="toggle toggle-init color-green"><input type=checkbox name=C2 @change=calCVS()> <span class=toggle-icon></span></label></li><li><span>Age &ge; 75 (+2 pt)</span> <label class="toggle toggle-init color-green"><input type=checkbox name=C3 @change=calCVS()> <span class=toggle-icon></span></label></li><li><span>Diabetes mellitus</span> <label class="toggle toggle-init color-green"><input type=checkbox name=C4 @change=calCVS()> <span class=toggle-icon></span></label></li><li><span>Stroke/TIA/thrombo-embolism (+2 pt)</span> <label class="toggle toggle-init color-green"><input type=checkbox name=C5 @change=calCVS()> <span class=toggle-icon></span></label></li><li><span>Vascular disease</span> <label class="toggle toggle-init color-green"><input type=checkbox name=C6 @change=calCVS()> <span class=toggle-icon></span></label></li><li><span>Age 65-74</span> <label class="toggle toggle-init color-green"><input type=checkbox name=C7 @change=calCVS()> <span class=toggle-icon></span></label></li><li><span>Sex category: Female</span> <label class="toggle toggle-init color-green"><input type=checkbox name=C8 @change=calCVS()> <span class=toggle-icon></span></label></li></ul></div><div class="list simple-list"><ul><li><span>CHA<sub>2</sub>DS<sub>2</sub>-VASc score:</span><div class=float-right><b><span id=CHA2DS2VASCscore>0</span></b></div></li><li><span>Adjusted stroke rate (% year):</span><div class=float-right><span id=CHA2DS2VASCrisk>0%</span></div></li></ul></div><div class=block-footer>Score &ge;2: high stroke risk</div></form></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};